module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER ONE")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("A "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("BABY")]), _vm._v("!")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("On her doorstep!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This couldn’t be happening. There must be some sort of mistake. And it certainly hadn’t been made by her!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gemini continued to look blankly at the woman standing beside the carrycot, cursing the fact it was the housekeeper’s day off. She had no doubts that Mrs James would have dealt with this situation in her usual capable manner—probably without bothering Gemini with it at all!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As it was, Gemini had been caught completely off guard when she’d opened the door herself, answering the ring of the doorbell, and found this other woman standing on her doorstep. With a baby in a carrycot she claimed she was here to deliver to Gemini!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gemini shook her head confidently, dark shoulder-length hair swinging silkily against her cheeks. ‘I never did believe that story about the stork,’ she said dryly. ‘And I hate to disappoint you, but I think there’s been some sort of mistake—’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No mistake,’ the other woman assured her happily. ‘Jemima gave me detailed instructions of how to get here, and exactly who I was to leave the baby with. After seeing you, I would have been in no doubt anyway.’ The young woman laughed. ‘The two of you are identical!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gemini had stopped listening the moment her twin sister’s name was mentioned, although she stiffened resentfully as the last remark registered. She and Jemima might be identical in looks, but there the similarity ended!")])]), _c('a', {
    attrs: {
      "id": "page06"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But if her twin "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("were")]), _vm._v(" behind this woman’s presence here, Gemini knew she’d better listen to what she had to say…!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She stepped back, holding the door open. ‘Perhaps you had better come inside,’ she sighed. ‘And bring—the baby with you,’ she added reluctantly, not sure if the baby were a boy or a girl—and not particularly interested either way!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’m Janey Reynolds, by the way. Jessica’s nanny,’ the other woman said chattily as they walked down the thickly carpeted hallway. Janey carried the bulky carrycot in front of her, releasing its weight onto the sofa once they were in Gemini’s sitting-room, and then looked about the obviously wealthy comfort of the room with interest.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Gemini Stone,’ she introduced herself vaguely, staring at the carrycot as if it were an alien being. Which it was, to her. She had no children of her own. And she wasn’t particularly interested in any her sister might have produced, either!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Or perhaps this was all just someone’s idea of a joke. But it was June, not April, and she didn’t think any of her friends were crazy enough to involve a baby in any prank they pulled on her. Although she only had Janey Reynolds’ word for it that there was a baby in the carrycot; maybe it was empty, and just another part of the joke…?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Beautiful, isn’t she?’ Janey Reynolds prompted as Gemini leant cautiously over the side of the carrycot.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She looked like any other baby as far as Gemini was concerned: very pink, very wrinkled, with sparse dark hair—and, thankfully, at this moment her eyes were closed in sleep!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gemini moved away from the cot as if she had been stung. There was definitely a baby in there. And if this woman were to be believed her sister was involved in its existence.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Am I to take it you work for my sister, Jemima?’ She looked at the younger woman with narrowed eyes.")])]), _c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Janey Reynolds looked to be in her early twenties, with an open, friendly face, lightly sprinkled with freckles, and reddish-blonde hair that was brushed back from that gamine face. Her slender figure was clothed in a tee shirt and fitted denims. Ideal wear for looking after a baby.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Whereas Gemini’s own clothes—a silk blouse the same cobalt blue as her eyes and black silk trousers contoured to the tall slenderness of her body had been designed by Gemini herself, to be fashionable as well as comfortable. But, being silk, they were certainly not baby-proof. ‘As Jessica’s nanny,’ Janey nodded, still smiling. ‘I would’ve thought Jemima would have mentioned that to you…?’ She frowned slightly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As Gemini and Jemima hadn’t seen each other for well over a year now, and the baby in the carrycot looked very young indeed, there wasn’t much likelihood of that. In fact, if her sums were correct, Jemima couldn’t even have been pregnant the last time they’d met. Which begged the question—who was the baby’s father…?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Please, sit down,’ Gemini invited coolly, sitting down in the armchair opposite the other woman. ‘Have you worked for my sister for very long?’ she queried lightly, feeling totally in the dark here; she hadn’t even known there was a baby, let alone how old it was!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Janey shook her head. ‘Since the day she came out of the nursing-home. About six weeks,’ she supplied as Gemini still looked blank.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I see,’ she said slowly—not seeing anything at all.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jemima had given birth six weeks ago…. It seemed incredible that her twin could have gone through pregnancy, and then childbirth, without Gemini knowing anything about it. Of course, the emotional connection they’d used to have as children had gone long ago, but even so Gemini thought she would have felt something!")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("Janey looked a little less sure of herself now. ‘Jemima ")]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("has been delayed in the States for the weekend at least,’ she said slowly. ‘I would have thought she’d have called you?’")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Called me?’ Gemini was totally at a loss now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Not only had she not seen Jemima for over a year, the two of them hadn’t spoken to each other on the telephone, either; the rift between them was just too deep. Why on earth should Janey Reynolds assume that they might have spoken to each other now. Although the obvious answer to that was that the younger woman wasn’t aware there "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" a rift. Typical of Jemima!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘About looking after Jessica for a few days until she returns,’ Janey explained with a frown. ‘You see—’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What!’ Gemini got up abruptly, totally aghast as what the other woman had just said. She stood as tall as any model, with the sort of slender figure that showed clothes well. Except she didn’t model clothes; she designed them. GemStone was becoming one of the leading designer labels in the world, and Gemini herself was one of the best showpieces for her own clothes: tall, elegant, with a cool beauty the press found as photogenic as each of her new collections.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But that cool beauty was definitely ruffled at the moment—when was it ever anything else when her sister was involved?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’m sure you must have misunderstood Jemima,’ she told the other woman, pleasantly enough, determined not to become panicked. If she could manage to design and organise a new collection of clothes every season, she could definitely handle this—whatever this might be!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I don’t think so.’ Janey shook her head, still frowning. ‘As I said, Jemima has been delayed in America—’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I understood that bit,’ Gemini assured her coolly. ‘I simply don’t see what that delay has to do with me. You informed me that you are Jessica’s nanny—’")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, I am.’ Janey Reynolds had started to look upset now. ‘But it’s my wedding day tomorrow.’ She gave a self-conscious smile, ‘So I obviously can’t take care of Jessica until Jemima does return. Your sister assured me that it would be no problem for you to look after Jessica for a few days.’ She chewed worriedly on her bottom lip at this last disclosure.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Of course it would be no problem for Jemima if her baby were left with Gemini—it was Gemini who had the problem with it. For one thing, she knew absolutely nothing about taking care of babies, and secondly, this latest escapade was just typical of Jemima—too busy with her own life to take care of her own responsibilities!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Do you have a telephone number in America where Jemima might be reached?’ she prompted impatiently. ‘I’m sure if we speak to her this can all be sorted out in a matter of minutes.’ Because Gemini would insist that her sister get herself back here, delay or no delay, and take care of her own daughter!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Janey looked pained. ‘She’s following through some story or other, and she’s usually the one to call me…’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gemini wondered just how often ‘usually’ was where her journalist sister was concerned; Jemima was dogged when it came to her work, and stopped at nothing to acquire an exclusive. Or anything else she wanted, for that matter. As Gemini knew to her cost…!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Just how long has my sister been in America?’ she questioned shrewdly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Almost a week,’ Janey revealed reluctantly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Unbelievable, when her baby was obviously so young. Although anything was possible with Jemima. ‘So you have no way of contacting her.’ Gemini spoke almost to herself. ‘And it’s your wedding day tomorrow, so naturally you aren’t going to be around to take care of the baby for some time…’ She looked questioningly at the nanny.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’m going on a two-week honeymoon to Barbados,’ Janey replied, obviously aware by now that her presence here, with Jemima’s baby, was a complete surprise to Gemini.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gemini should have known; only Jemima would take on for her baby a nanny who was going on holiday mere weeks after being employed!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But none of this mental berating of her sister changed the fact that there was a six-week-old baby that needed looking after—or the fact that Gemini, as her aunt, was the one expected to do it!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At twenty-nine, Gemini had never even considered having any children of her own. She was a career woman, through and through, her designs the only ‘babies’ she was interested in.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Although now it looked as if, for a few days at least, she might have to take an interest in a six-week-old baby called Jessica!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jemima really did have the most colossal damn cheek; the rift between the two sisters had been abrupt and final, over a year ago. How on earth did Jemima have the nerve to dump her baby on Gemini now after the way she had behaved then…?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Of course, it didn’t help that she knew Nick was going to be absolutely furious about the situation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Oh, damn Nick, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and")]), _vm._v(" what he thought of the situation. If he were around as much this weekend as he had been the last few months he wouldn’t even know she’d ever had a baby in the house, let alone that it was Jemima’s!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She wasn’t seriously contemplating looked after Jessica herself, was she. She knew nothing about babies, not how to feed them or look after them, and at only six weeks old she was sure Jessica was going to need a lot of both. Besides, she was Jemima’s baby…!")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("No, the idea was utterly ridiculous. She couldn’t do it. ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("‘I suppose it’s too late to engage a temporary nanny for the baby until Jemima comes back…?’ she asked, frowning.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Janey grimaced. ‘At six o’clock on a Friday evening? Not much chance, I would have thought.’ She shrugged.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Then why hadn’t she brought the baby here earlier. Damn it—")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jemima…. Her sister was the one who’d instructed Janey on what she was to do, so no doubt the timing of it had been planned by Jemima too. She didn’t doubt for a moment that her irresponsible sister, in spite of the rift between the two of them, would think of it all as a big joke, would find the image of Gemini trying to cope with her very young daughter absolutely hilarious.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’m really sorry about this, Miss Stone.’ Janey Reynolds had obviously realised by now that, in spite of what Jemima might or might not have told her, there was something very wrong here.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gemini shook her head. ‘You can be assured that I am well aware that none of this—situation is of your doing.’ She sighed. ‘I think you’d better go and get the rest of Jessica’s things in from the car.’ And there was probably going to be a lot of them for a baby as young as Jessica. ‘I’m sure you must be anxious to be on your way,’ she added flatly, wondering how she was going to cope. But at the same time she knew that Jemima had left her little choice.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Considering Jemima’s dedication to her own career, Gemini couldn’t even begin to imagine what had made her sister go ahead and have this baby. Admittedly Jemima had always been the one who, when they were children, had stayed indoors and played with her dolls, while Gemini had been climbing trees with the neighbours’ sons, but it seemed as though Jessica’s birth was just a mere hiccup in Jemima’s life, a small inconvenience before she resumed following her own pursuits.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Janey hesitated on her way out to the car. ‘Jessica is due for a feed in a few minutes; would you like me to stay and show you how to make the formula up, and give her the bottle…?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Considering this young woman must have many other things on her mind at this time, Gemini appreciated the offer. And took unashamed advantage of it. It wasn’t going to help anyone if, in her complete ignorance concerning the care of babies, she did it all wrong and made the baby ill!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It looked simple enough as she watched Janey do it—even the nappy changing didn’t seem that horrendous. And immediately after her feed and change Jessica went back to sleep. Nothing to it!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Er—I’ll leave you my telephone number, if you like?’ Janey seemed reluctant to go once the time came—obviously realising Gemini was a complete novice when it came to babies, and probably fearing for Jessica’s safety.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Which was more than could be said for Jemima, Gemini inwardly berated. She would take great pleasure in thinking of suitable retribution for her sister over the weekend; this had to be the worst thing Jemima had ever done to her!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Well…almost, she remembered hardily.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And as for taking care of the baby..! If Jemima thought she had landed Gemini with something she couldn’t handle, then she was going to be in for a big disappointment.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘That’s very kind of you.’ She accepted Janey’s offer, putting her card next to the telephone. ‘But I’m sure I won’t be needing it,’ she added confidently.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Four hours later she wasn’t so sure about that. It had all looked so easy when Janey had fed and changed the baby, but actually putting that theory into practice proved much more difficult to Gemini than it had looked!")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("For one thing Gemini couldn’t seem to get the hang of holding the baby while trying to feed her at the same time. And then the nappy didn’t seem to want to stay on. In the ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("end she secured it into place by the poppers on Jessica’s bodyvest.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But finally, over an hour later—much longer than it had taken Janey Reynolds!—the baby had been fed and changed and was back asleep in her carrycot, giving Gemini the chance to catch up on some of her own chores before going to bed herself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But it seemed no sooner had she fallen asleep than she was woken up again by Jessica’s whimpering cry from the spare bedroom. And those slight whimpers grew to enormous proportions before Gemini could wake herself up enough to deal with it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("How on earth did new mothers cope with this for weeks, sometimes months at a time? Gemini wondered as she stumbled about the kitchen, trying to hold Jessica wrapped in a shawl in one arm and warm the bottle with the other hand.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Not that holding the baby stopped her crying. The noise Jessica was making now seemed to go straight through Gemini’s head, reverberating around the kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But at last the bottle was warmed and she sat down thankfully on one of the chairs around the kitchen table to give the baby her milk. Only to find Jessica didn’t want it, pushing the bottle repeatedly from her lips with her little pink tongue, and beginning that nerve-shattering wail once again!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gemini’s nerves were already fraught from the crying—now what did she do. Her first instinct was to telephone Janey Reynolds and find out the answer to that. But a glance at the clock showed her it was one o’clock in the morning, hardly a very sociable time to be telephoning anyone!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("One o’clock…?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("Janey had said the baby fed approximately every four ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("hours, and it was only three hours since Jessica’s last feed, even less than that from when she had first begun to cry.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Was Jessica sick? Did she have a temperature? What—?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What the hell is going on here?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gemini looked up with a start, staring towards the doorway, wincing as she saw her husband standing there. Just what she needed when she was so harassed, and definitely looking less than her best.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When had he arrived home? Some time ago, by the look of him; he was obviously naked beneath the black silk robe he had belted about his waist, his dark hair ruffled from sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A robe was a luxury she hadn’t allowed herself when she’d hurried out of bed earlier to see to Jessica; she was wearing only pale grey silk pyjamas, and the baby had spat most of her milk down them in her distress!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So much for thinking earlier that Nick would probably never know there had ever been a baby in the house!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gemini stood up abruptly, stilling holding the baby, whose wails seemed to have turned to hiccuping sobs now. ‘What does it look like?’ she snapped, showing her impatience with the question.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Nick blinked, green eyes narrowing in his ruggedly handsome face. ‘It looks like a baby—but I’m sure this must all be just a bad dream; we don’t have a baby!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Considering that she and Nick had been married for more than a year now, and had occupied separate bedrooms from the beginning of their marriage, that was highly unlikely.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She and Nick had what could only be termed a business marriage, a marriage that suited both of them. At least, it had a year ago. She wasn’t so sure that was the case now. For either of them. But for different reasons…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("‘That’s very astute of you, Nick,’ she drawled mockingly. ‘Although it doesn’t help in solving the problem of how to stop Jessica crying!’ she added raggedly as the baby ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("continued to wail. ‘I wasn’t expecting you home yet,’ she added accusingly.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I completed my business early,’ he dismissed distractedly, striding into the kitchen with his usual ease of movement, taking the baby from her unresisting hands, frowning down into the little heart-shaped face. ‘What’s the matter, Jessica?’ he murmured soothingly to the baby. ‘We can’t help you if you—’ He stopped, frowning across at the watching Gemini. ‘Have you tried changing her nappy?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gemini watched in fascination as her tall, arrogant husband strolled about the kitchen carrying the slightness that was Jessica. He was one of the most handsome men Gemini had ever set eyes on, possessed of a physical magnetism that she’d been unaware of when they first married.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When had that changed?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She wasn’t really sure. She only knew that she felt a deep sense of dissatisfaction in their marriage now, a longing for something more.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Gemini!’ Nick prompted, impatient with receiving no response to his question of a few minutes ago.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She bristled resentfully. ‘Janey said not to change her nappy until after the feed—’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘And I’m sure that Janey—whoever she might be!—is probably correct about the usual order of things—if it weren’t for the fact that Jessica is extremely damp!’ Nick grimaced as he pointedly peeled back the shawl the baby was wrapped in to reveal her sleepsuit was soaking wet!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gemini felt the hot colour enter her cheeks, feeling a total sense of inadequacy where this baby was concerned. And not being in control of a situation was something she wasn’t in the least comfortable with. Especially around Nick!")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("She hadn’t even thought to check the baby’s nappy when she’d got Jessica up a short time ago and wrapped her in the shawl. Instead she’d been intent only on warming the ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("bottle so that the baby would stop crying. Except that she hadn’t..! And the reason for that was now obvious.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was even more so once Gemini had stripped off the wet clothing to find that the nappy she had had such difficulty with at the last feed had somehow moved sideways while Jessica slept. The nappy itself was almost dry, leaving Jessica’s clothes very wet. And the situation was made all the worse by the fact that all the time she was undressing the baby Nick was watching her actions with those mocking green eyes narrowed, making her feel more inadequate than ever.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She would never forgive Jemima for this!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Here, let me,’ Nick muttered impatiently, obviously tired of her efforts to replace the nappy and taking over the task himself, achieving an almost perfect result within seconds. Much to Gemini’s chagrin. Was there nothing that Nick wasn’t totally competent at?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘When did you get to be such an expert on babies?’ she muttered resentfully as Nick put Jessica’s clean clothes on seemingly without effort, too. The baby was clean and dry minutes later, the crying having stopped as she began to fall back to sleep cradled in Nick’s strong, comforting arms.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’m no expert, Gemini,’ Nick drawled derisively. ‘I just used a little common sense. Besides…’ He shrugged. ‘I’m ten years older than Danny; I used to enjoy helping out with him when I was a child.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gemini stiffened at the mention of his younger brother. By tacit agreement neither she nor Nick had talked about Danny or Jemima since the first day of their own marriage. The reason for that was simple enough; there had been nothing left to say about either of them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And Gemini couldn’t help but be surprised at Nick mentioning Danny now…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("Although it did give her the perfect opening for her next comment…! ‘Nick, Jessica is Jemima’s baby,’ she told him ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("baldly, her gaze narrowing as she watched closely for his reaction to the announcement.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There wasn’t one. At least, not one that he allowed to be visible to Gemini. But that was typical of Nick, too. Her husband was a man who showed little emotion about anything except the mockery that seemed to be such a natural part of his nature. Although Gemini was sure that inside he had to be churning with some sort of emotion. He had to be!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Because if all their lives hadn’t been turned upside down fifteen months ago by Jemima’s selfishness, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he")]), _vm._v(" could have been Jessica’s father…!")])])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page17"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2428b300","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459204560_ch01.vue
// module id = 81
// module chunks = 0